import { useConfirmationsStore } from '@/stores/confirmations'
import { storeToRefs } from 'pinia'

const useConfirmations = () => {
	const { setHotelConfirmations, setGeneralConfirmations, setStatusMessage } =
		useConfirmationsStore()

	const {
		hotelConfirmations,
		generalConfirmations,
		confirmations,
		statusMessage,
		isManualReservation,
		paymentConfirmationInfo,
	} = storeToRefs(useConfirmationsStore())

	return {
		hotelConfirmations,
		generalConfirmations,
		statusMessage,
		confirmations,
		isManualReservation,
		paymentConfirmationInfo,

		setHotelConfirmations,
		setGeneralConfirmations,
		setStatusMessage,
		resetConfirmations() {
			setHotelConfirmations([])
			setGeneralConfirmations([])
		},
	}
}

export default useConfirmations
